import { render, staticRenderFns } from "./standard-rates.vue?vue&type=template&id=3f34b7e5&scoped=true&"
import script from "./standard-rates.vue?vue&type=script&lang=ts&"
export * from "./standard-rates.vue?vue&type=script&lang=ts&"
import style0 from "./standard-rates.vue?vue&type=style&index=0&id=3f34b7e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34b7e5",
  null
  
)

export default component.exports